export const baseURL= "https://backend.shieldxsports.com/api/v1/"

//config endpoint
export const Config={
    CONFIG_API:baseURL+"webconfig",
}

export const Save={
    SAVE_API:baseURL+"customer/addToSave",
    GETSAVE_API:baseURL+"customer/getSaveList",
}
//register endpoint
export const register={
    REGISTER_API:baseURL+"customer/register",
    LOGIN_API:baseURL+"customer/login",
    LOGOUT_API:baseURL+"customer/logout",
}

//profile endpoint
export const profile={
    UPDATEPROILE_API:baseURL+"customer/updateprofile",
    PROILE_API:baseURL+"customer/profile",
    IMAGEUPDATE_API:baseURL+"customer/updateprofileimg",
    ADDUSER_API:baseURL+"customer/addUserAddress",
    UPDATEUSER_API:baseURL+"customer/updateUserAddress",
    DELETEUSER_API:baseURL+"customer/deleteUserAddress",
    GETUSER_API:baseURL+"customer/getUserAddressList",
}

//category and Product endpoint
export const menu={
    MENU_API:baseURL+"getAllMenus",
    MENUSLUG_API:baseURL+"getCategoriesByMenuSlug",
    product_API:baseURL+"getAllProductByCategory",
    productDetails_API:baseURL+"getProductBySlug",
    allProduct_API:baseURL+"getAllProductByHomeCategory",
    allEvent_API:baseURL+"getAllEventProduct",
    ProductLevel_API:baseURL+"",
}

//stock Product endpoint
export const stock={
    STOCK_API:baseURL+"checkProductStock",
}

//offer Product endpoint
export const offer={
    OFFER_API:baseURL+"getAllOffers",
}

//Place Order endpoint
export const PlaceOrder_endpoint={
    GetPaymentKey_API:baseURL+"customer/createPaymentIntent",
    GetPaymentVerify_API:baseURL+"customer/verifyPayment",
    PlaceOrder_API:baseURL+"customer/placeOrder",
    PaymentAdd_API:baseURL+"customer/paymentAdd",
    VerifyPayment_API:baseURL+"customer/verifyPayments",
    OrderList_API:baseURL+"customer/getOrderList",
    OrderDetails_API:baseURL+"customer/getOrderDetailById",
}

//coupon endpoint
export const check_endpoint={
    coupon_API:baseURL+"customer/applyCoupon",
}

//forget passward endpoint
export const ForgetPassward_endpoint={
    forgetPassward_API:baseURL+"forgotPassword",
}

//forget passward endpoint
export const Three_endpoint={
    Three_API:baseURL+"customer/customizeProductByUser",
}

//glb endpoint
export const glb_endpoint={
    Glb_API:baseURL+"getGlbBySubcategory",
    OnlyGlb_API:baseURL+"getGlbByItemId",
}

//add to cart
export const addToCart_endpoint={
    addToCart_API:baseURL+"customer/addToCart",
    updateCart_API:baseURL+"customer/addToCart",
    removeCart_API:baseURL+"customer/deleteCartById",
    addToCartGLB_API:baseURL+"customer/addToCart1",
    getCart_API:baseURL+"customer/getCartList",
    updateCartQuantity_API:baseURL+"customer/updateCartQuantity",
}

//add to cart
export const glbSizeList_endpoint={
    sizeList_API:baseURL+"getAllSizeList",
}

//country
export const country_endpoint={
    country_API:baseURL+"getCountryList",
}

//enquery
export const enquery_endpoint={
    enquery_API:baseURL+"enquiries",
}

//Filter
export const Fiter_endpoint={
    Filter_API:baseURL+"getAllProductByCategoryFilter",
    HomeFilter_API:baseURL+"getAllProductByHomeCategoryFilter",
}

//Filter
export const productStyle_endpoint={
    productStyle_API:baseURL+"getAllProductStyle",
}

//blog
export const blog_endpoint={
    blog_API:baseURL+"getAllBlogs",
    blogDetails_API:baseURL+"getBlogBySlug",
}

//review


export const review={
    review_API:baseURL+"getAllTestimonials",
    submitReview_api:baseURL+"customer/addUpdateRatingByProductId"
}

//teamorder

export const teamOrder={
    teamProductsFilter:baseURL+'getAllProductForTeamFilterList',
    teamProductsList:baseURL+'getAllProductForTeam',
    teamFilteredProducts:baseURL+'getAllProductForTeam?limit=10&page=1'

}

export const coupon={
    fetchingCoupon:baseURL+'getAllCouponList',
    applyCoupon:baseURL+'customer/applyCoupon',
    getCouponAndDelivery:baseURL+"customer/getCouponAndDelivery"
}


